(function () {

  'use strict';

  eclipseApp.directive('uteMiniCart', function () {

    return {
      restrict: 'AE',
      scope: true,
      replace: true,
      templateUrl: function(elem,attrs) {
         return (attrs.redesign === 'true') ?  'modules/core/views/redesign-mini-cart.html' :  'modules/core/views/mini-cart.html'
      },
      controller: 'cartCtrl'
    };

  });

})();
